import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import ClickOutside from 'vuetify/lib/directives/click-outside';

import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm$model;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VForm, {
    ref: "form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_vm.isDeletingTemplate ? _c(VSkeletonLoader, {
    staticClass: "mb-6",
    attrs: {
      width: "100%",
      type: "text"
    }
  }) : _vm.isEditing ? _c(VCombobox, {
    staticClass: "mb-6",
    class: this.templateRequired ? "required" : "",
    attrs: {
      items: _vm.templates,
      "item-text": "name",
      "item-value": "id",
      label: !_vm.placeholdersReady ? "Loading" : "Select a template",
      "hide-details": "auto",
      rules: [_vm.rules.mustSelectValue],
      disabled: !_vm.placeholdersReady
    },
    on: {
      input: _vm.changeTemplate
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", [_vm._v(_vm._s(item.name))]), _c(VSpacer), _c(VListItemAction, [_c("div", {
          staticClass: "list-item-actions"
        }, [_c(VBtn, {
          attrs: {
            icon: ""
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.editTemplate(item.id);
            }
          }
        }, [_c(VIcon, [_vm._v("mdi-pencil")])], 1), _c(VBtn, {
          attrs: {
            icon: ""
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.deleteTemplate(item.id);
            }
          }
        }, [_c(VIcon, [_vm._v("mdi-close")])], 1)], 1)])];
      }
    }, _vm.templates.length ? {
      key: "append-item",
      fn: function fn() {
        return [_c(VListItem, {
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.newTemplate.apply(null, arguments);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            dark: ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" New template ")], 1)];
      },
      proxy: true
    } : null, !_vm.templates.length ? {
      key: "no-data",
      fn: function fn() {
        return [_c(VListItem, {
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.newTemplate.apply(null, arguments);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            dark: ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" New template ")], 1)];
      },
      proxy: true
    } : null, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.id ? _c("div", [_vm._v(_vm._s(item.name))]) : _vm._e()];
      }
    }], null, true),
    model: {
      value: _vm.model,
      callback: function callback($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  }) : _c(VTextField, {
    staticClass: "required mb-6",
    attrs: {
      dense: "",
      rules: [_vm.rules.mustNotBeEmpty],
      label: "Name",
      "hide-details": "auto"
    },
    on: {
      input: _vm.onModelUpdate
    },
    model: {
      value: _vm.model.name,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "name", $$v);
      },
      expression: "model.name"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      dense: "",
      rules: [_vm.rules.mustNotBeEmpty, _vm.rules.mustBeEmail],
      label: "From",
      "hide-details": "auto"
    },
    on: {
      input: _vm.onModelUpdate
    },
    model: {
      value: _vm.model.from,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "from", $$v);
      },
      expression: "model.from"
    }
  }), _c("p", {
    staticClass: "text-left text-xs py-1"
  }, [_vm._v(" This email address will be used as the from address while sending. A copy of this e-mail will be automatically sent to the « from » address. ")]), _vm.isEditing ? _c(VCombobox, {
    staticClass: "required mb-6",
    attrs: {
      label: "Send to",
      items: _vm.model.mailHistories.filter(function (x) {
        return !_vm.model.sendTo.includes(x.email);
      }),
      dense: "",
      multiple: "",
      "append-icon": "",
      chips: "",
      "deletable-chips": "",
      rules: [_vm.rules.mustNotBeEmpty, _vm.rules.mustBeEmails],
      "hide-details": "auto"
    },
    on: {
      input: _vm.onModelUpdate
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c(VListItem, {
          on: {
            click: function click($event) {
              _vm.model.sendTo = [].concat(_toConsumableArray(_vm.model.sendTo), [item.email]);
              _vm.onModelUpdate();
            }
          }
        }, [_c(VListItemContent, [_c(VListItemTitle, [_c("i", {
          staticClass: "fas fa-history mr-2"
        }), _vm._v(" " + _vm._s(item.email) + " ")])], 1)], 1)];
      }
    }], null, false, 3603132644),
    model: {
      value: _vm.model.sendTo,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "sendTo", $$v);
      },
      expression: "model.sendTo"
    }
  }) : _vm._e(), _c(VTextField, {
    ref: "subject",
    staticClass: "required",
    attrs: {
      dense: "",
      label: "Subject",
      rules: [_vm.rules.mustNotBeEmpty]
    },
    on: {
      focus: function focus($event) {
        _vm.lastFocus = "subject";
      },
      blur: function blur($event) {
        _vm.lastFocus = "subject";
      },
      input: _vm.onModelUpdate
    },
    model: {
      value: _vm.model.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "subject", $$v);
      },
      expression: "model.subject"
    }
  }), _c("div", {
    attrs: {
      id: "toolbar_".concat(_vm.$vnode.key)
    }
  }, [_c("span", {
    staticClass: "ql-formats"
  }, [_c("select", {
    staticClass: "ql-header"
  }, [_c("option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v("Heading")]), _c("option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v("Subheading")]), _c("option", {
    attrs: {
      selected: ""
    }
  }, [_vm._v("Normal")])])]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("button", {
    staticClass: "ql-bold"
  }), _c("button", {
    staticClass: "ql-italic"
  }), _c("button", {
    staticClass: "ql-underline"
  }), _c("button", {
    staticClass: "ql-strike"
  })]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("select", {
    staticClass: "ql-color"
  }, [_c("option", {
    attrs: {
      selected: "selected"
    }
  }), _c("option", {
    attrs: {
      value: "#e60000"
    }
  }), _c("option", {
    attrs: {
      value: "#ff9900"
    }
  }), _c("option", {
    attrs: {
      value: "#ffff00"
    }
  }), _c("option", {
    attrs: {
      value: "#008a00"
    }
  }), _c("option", {
    attrs: {
      value: "#0066cc"
    }
  }), _c("option", {
    attrs: {
      value: "#9933ff"
    }
  }), _c("option", {
    attrs: {
      value: "#ffffff"
    }
  }), _c("option", {
    attrs: {
      value: "#facccc"
    }
  }), _c("option", {
    attrs: {
      value: "#ffebcc"
    }
  }), _c("option", {
    attrs: {
      value: "#ffffcc"
    }
  }), _c("option", {
    attrs: {
      value: "#cce8cc"
    }
  }), _c("option", {
    attrs: {
      value: "#cce0f5"
    }
  }), _c("option", {
    attrs: {
      value: "#ebd6ff"
    }
  }), _c("option", {
    attrs: {
      value: "#bbbbbb"
    }
  }), _c("option", {
    attrs: {
      value: "#f06666"
    }
  }), _c("option", {
    attrs: {
      value: "#ffc266"
    }
  }), _c("option", {
    attrs: {
      value: "#ffff66"
    }
  }), _c("option", {
    attrs: {
      value: "#66b966"
    }
  }), _c("option", {
    attrs: {
      value: "#66a3e0"
    }
  }), _c("option", {
    attrs: {
      value: "#c285ff"
    }
  }), _c("option", {
    attrs: {
      value: "#888888"
    }
  }), _c("option", {
    attrs: {
      value: "#a10000"
    }
  }), _c("option", {
    attrs: {
      value: "#b26b00"
    }
  }), _c("option", {
    attrs: {
      value: "#b2b200"
    }
  }), _c("option", {
    attrs: {
      value: "#006100"
    }
  }), _c("option", {
    attrs: {
      value: "#0047b2"
    }
  }), _c("option", {
    attrs: {
      value: "#6b24b2"
    }
  }), _c("option", {
    attrs: {
      value: "#444444"
    }
  }), _c("option", {
    attrs: {
      value: "#5c0000"
    }
  }), _c("option", {
    attrs: {
      value: "#663d00"
    }
  }), _c("option", {
    attrs: {
      value: "#666600"
    }
  }), _c("option", {
    attrs: {
      value: "#003700"
    }
  }), _c("option", {
    attrs: {
      value: "#002966"
    }
  }), _c("option", {
    attrs: {
      value: "#3d1466"
    }
  })]), _c("select", {
    staticClass: "ql-background"
  }, [_c("option", {
    attrs: {
      value: "#000000"
    }
  }), _c("option", {
    attrs: {
      value: "#e60000"
    }
  }), _c("option", {
    attrs: {
      value: "#ff9900"
    }
  }), _c("option", {
    attrs: {
      value: "#ffff00"
    }
  }), _c("option", {
    attrs: {
      value: "#008a00"
    }
  }), _c("option", {
    attrs: {
      value: "#0066cc"
    }
  }), _c("option", {
    attrs: {
      value: "#9933ff"
    }
  }), _c("option", {
    attrs: {
      selected: "selected"
    }
  }), _c("option", {
    attrs: {
      value: "#facccc"
    }
  }), _c("option", {
    attrs: {
      value: "#ffebcc"
    }
  }), _c("option", {
    attrs: {
      value: "#ffffcc"
    }
  }), _c("option", {
    attrs: {
      value: "#cce8cc"
    }
  }), _c("option", {
    attrs: {
      value: "#cce0f5"
    }
  }), _c("option", {
    attrs: {
      value: "#ebd6ff"
    }
  }), _c("option", {
    attrs: {
      value: "#bbbbbb"
    }
  }), _c("option", {
    attrs: {
      value: "#f06666"
    }
  }), _c("option", {
    attrs: {
      value: "#ffc266"
    }
  }), _c("option", {
    attrs: {
      value: "#ffff66"
    }
  }), _c("option", {
    attrs: {
      value: "#66b966"
    }
  }), _c("option", {
    attrs: {
      value: "#66a3e0"
    }
  }), _c("option", {
    attrs: {
      value: "#c285ff"
    }
  }), _c("option", {
    attrs: {
      value: "#888888"
    }
  }), _c("option", {
    attrs: {
      value: "#a10000"
    }
  }), _c("option", {
    attrs: {
      value: "#b26b00"
    }
  }), _c("option", {
    attrs: {
      value: "#b2b200"
    }
  }), _c("option", {
    attrs: {
      value: "#006100"
    }
  }), _c("option", {
    attrs: {
      value: "#0047b2"
    }
  }), _c("option", {
    attrs: {
      value: "#6b24b2"
    }
  }), _c("option", {
    attrs: {
      value: "#444444"
    }
  }), _c("option", {
    attrs: {
      value: "#5c0000"
    }
  }), _c("option", {
    attrs: {
      value: "#663d00"
    }
  }), _c("option", {
    attrs: {
      value: "#666600"
    }
  }), _c("option", {
    attrs: {
      value: "#003700"
    }
  }), _c("option", {
    attrs: {
      value: "#002966"
    }
  }), _c("option", {
    attrs: {
      value: "#3d1466"
    }
  })])]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("button", {
    staticClass: "ql-list",
    attrs: {
      value: "ordered"
    }
  }), _c("button", {
    staticClass: "ql-list",
    attrs: {
      value: "bullet"
    }
  })]), _c("span", {
    staticClass: "ql-formats"
  }, [_c("button", {
    staticClass: "ql-link"
  }), _c("button", {
    staticClass: "ql-clean"
  })]), _c("button", {
    staticClass: "custom-button ql-custom",
    class: !_vm.placeholders ? "disabled" : "",
    attrs: {
      id: "custom-button_".concat(_vm.$vnode.key)
    }
  }, [_vm._v(" Insert placeholders ")])]), _c("div", {
    attrs: {
      id: "editor_".concat(_vm.$vnode.key)
    }
  }), _vm.hasContentError ? _c("div", {
    staticClass: "errorLabel mt-1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "0.75rem"
    }
  }, [_vm._v(" The content is required ")]) : _vm._e(), _vm.placeholdersShown ? _c("div", {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsidePlaceholders,
      expression: "clickOutsidePlaceholders"
    }],
    staticClass: "placeholders-menu"
  }, _vm._l(Object.entries(_vm.placeholders), function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      values = _ref5[1];
    return _c("div", {
      key: "group_".concat(key),
      staticClass: "placeholders-group"
    }, [_c("div", {
      staticClass: "placeholders-title"
    }, [_vm._v(_vm._s(key))]), _c("div", {
      staticClass: "placeholders-items"
    }, _vm._l(values, function (placeholder, i) {
      return _c("div", {
        key: "placeholder_".concat(i),
        class: (_vm.isOrderOrInbound || _vm.isUser || _vm.isPurchaseOrder) && !placeholder.filledValue ? "placeholder-disabled" : "",
        on: {
          click: function click($event) {
            return _vm.clickPlaceholder(placeholder);
          }
        }
      }, [_vm._v(" " + _vm._s(placeholder.name) + " ")]);
    }), 0)]);
  }), 0) : _vm._e(), !_vm.noFiles && _vm.order ? _c("div", {
    staticClass: "documents-container"
  }, [_c("div", {
    staticClass: "documents-title"
  }, [_c("span", {
    staticClass: "--underline"
  }, [_vm._v("Add order-related documents")]), _vm._v(" (optional) ")]), _c("div", {
    staticClass: "documents-inputs"
  }, [!_vm.documents.length ? _c(VSkeletonLoader, {
    staticClass: "mt-2",
    attrs: {
      width: "100%",
      type: "text"
    }
  }) : _vm._l(_vm.documents.filter(function (x) {
    return !!x.document_urls.length;
  }), function (document) {
    return _c(VCheckbox, {
      key: document.name,
      attrs: {
        label: document.name + " (" + document.document_urls.map(function (x) {
          return x.name;
        }).join("") + ")",
        value: document,
        "hide-details": "auto"
      },
      on: {
        change: _vm.inputDocuments
      },
      model: {
        value: _vm.selectedDocuments,
        callback: function callback($$v) {
          _vm.selectedDocuments = $$v;
        },
        expression: "selectedDocuments"
      }
    });
  })], 2)]) : !_vm.noFiles && _vm.inboundDelivery ? _c("div", {
    staticClass: "documents-container"
  }, [_c("div", {
    staticClass: "documents-title"
  }, [_c("span", {
    staticClass: "--underline"
  }, [_vm._v("Add order-dispatch-related documents")]), _vm._v(" (optional) ")]), _c("div", {
    staticClass: "documents-inputs"
  }, [!_vm.documents.length ? _c(VSkeletonLoader, {
    staticClass: "mt-2",
    attrs: {
      width: "100%",
      type: "text"
    }
  }) : _vm._l(_vm.documents.filter(function (x) {
    return !!x.document_urls.length;
  }), function (document) {
    return _c(VCheckbox, {
      key: document.name,
      attrs: {
        label: document.name + " (" + document.document_urls.map(function (x) {
          return x.name;
        }).join("") + ")",
        value: document,
        "hide-details": "auto"
      },
      on: {
        change: _vm.inputDocuments
      },
      model: {
        value: _vm.selectedDocuments,
        callback: function callback($$v) {
          _vm.selectedDocuments = $$v;
        },
        expression: "selectedDocuments"
      }
    });
  })], 2)]) : _vm._e(), _c(VDivider), !_vm.noFiles && _vm.isOrderOrInbound && _vm.orderDocuments.length ? _c("div", {
    staticClass: "documents-container"
  }, [!_vm.loadings.isLoadingOrderFiles && _vm.orderDocuments.length ? _c("div", {
    staticClass: "documents-title mb-1"
  }, [_c("span", {
    staticClass: "--underline"
  }, [_vm._v("Add order-related global files")]), _vm._v(" (optional) "), _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2 ml-2",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.selectAllGlobalOrderFiles
    }
  }, [_vm._v(" Select all ")])], 1) : _vm._e(), _c("div", {
    staticClass: "documents-inputs large-row-gap"
  }, [_vm.loadings.isLoadingOrderFiles ? _c(VSkeletonLoader, {
    staticClass: "mt-2",
    attrs: {
      width: "100%",
      type: "text"
    }
  }) : _vm._l(_vm.orderDocuments, function (document) {
    return _c("div", {
      key: document.id
    }, [_c("div", {
      staticClass: "tag",
      class: !document.tag ? "font-italic" : "font-bold"
    }, [_c(VChip, {
      staticClass: "drawer-file-chip tag",
      attrs: {
        label: ""
      }
    }, [_c(VIcon, {
      staticClass: "tag-icon",
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-tag")]), _vm._v(" " + _vm._s(document.tag ? document.tag.name : "no tag") + " ")], 1)], 1), _c(VCheckbox, {
      attrs: {
        label: document.name,
        value: document,
        "hide-details": "auto"
      },
      on: {
        change: _vm.inputDocuments
      },
      model: {
        value: _vm.selectedDocuments,
        callback: function callback($$v) {
          _vm.selectedDocuments = $$v;
        },
        expression: "selectedDocuments"
      }
    })], 1);
  })], 2)]) : _vm._e(), _vm.orderDocuments.length ? _c(VDivider) : _vm._e(), !_vm.noFiles && _vm.isOrderOrInbound && _vm.wineDocuments.length ? _c("div", {
    staticClass: "documents-container"
  }, [!_vm.loadings.isLoadingWineFiles && _vm.wineDocuments.length ? _c("div", {
    staticClass: "documents-title mb-1"
  }, [_c("span", {
    staticClass: "--underline"
  }, [_vm._v("Add order-related wines files")]), _vm._v(" (optional) "), _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2 ml-2",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.selectAllWineFiles
    }
  }, [_vm._v(" Select all ")])], 1) : _vm._e(), _c("div", [_vm.loadings.isLoadingWineFiles ? _c(VSkeletonLoader, {
    staticClass: "mt-2",
    attrs: {
      width: "100%",
      type: "text"
    }
  }) : _c(VExpansionPanels, {
    attrs: {
      multiple: ""
    },
    model: {
      value: _vm.wineFilesPanels,
      callback: function callback($$v) {
        _vm.wineFilesPanels = $$v;
      },
      expression: "wineFilesPanels"
    }
  }, _vm._l(_vm.wineDocuments, function (wine, i) {
    return _c(VExpansionPanel, {
      key: i
    }, [_c(VExpansionPanelHeader, [_c("b", [_vm._v(_vm._s("".concat(wine.name)))]), _c("span", {
      staticClass: "mr-2 text-right"
    }, [_vm._v(" " + _vm._s("(".concat(wine.files.length, " file").concat(wine.files.length > 1 ? "s" : "", ")")) + " ")])]), _c(VExpansionPanelContent, [_c("div", {
      staticClass: "documents-inputs large-row-gap"
    }, _vm._l(wine.files, function (document) {
      return _c("div", {
        key: document.id
      }, [_c("div", {
        staticClass: "tag",
        class: !document.tag ? "font-italic" : "font-bold"
      }, [_c(VChip, {
        staticClass: "drawer-file-chip tag",
        attrs: {
          label: ""
        }
      }, [_c(VIcon, {
        staticClass: "tag-icon",
        attrs: {
          left: "",
          small: ""
        }
      }, [_vm._v("mdi-tag")]), _vm._v(" " + _vm._s(document.tag ? document.tag.name : "no tag") + " ")], 1)], 1), _c(VCheckbox, {
        attrs: {
          label: document.name,
          value: document,
          "hide-details": "auto"
        },
        on: {
          change: _vm.inputDocuments
        },
        model: {
          value: _vm.selectedDocuments,
          callback: function callback($$v) {
            _vm.selectedDocuments = $$v;
          },
          expression: "selectedDocuments"
        }
      })], 1);
    }), 0)])], 1);
  }), 1)], 1)]) : _vm._e(), _vm.wineDocuments.length ? _c(VDivider) : _vm._e(), !_vm.noFiles && _vm.isOrderOrInbound && _vm.wineryDocuments.length ? _c("div", {
    staticClass: "documents-container"
  }, [!_vm.loadings.isLoadingWineryFiles && _vm.wineryDocuments.length ? _c("div", {
    staticClass: "documents-title mb-1"
  }, [_c("span", {
    staticClass: "--underline"
  }, [_vm._v("Add order-related wineries files")]), _vm._v(" (optional) "), _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2 ml-2",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.selectAllWineryFiles
    }
  }, [_vm._v(" Select all ")])], 1) : _vm._e(), _c("div", [_vm.loadings.isLoadingWineryFiles ? _c(VSkeletonLoader, {
    staticClass: "mt-2",
    attrs: {
      width: "100%",
      type: "text"
    }
  }) : _c(VExpansionPanels, {
    attrs: {
      multiple: ""
    },
    model: {
      value: _vm.wineryFilesPanels,
      callback: function callback($$v) {
        _vm.wineryFilesPanels = $$v;
      },
      expression: "wineryFilesPanels"
    }
  }, _vm._l(_vm.wineryDocuments, function (winery, i) {
    return _c(VExpansionPanel, {
      key: i
    }, [_c(VExpansionPanelHeader, [_c("b", [_vm._v(_vm._s("".concat(winery.name)))]), _c("span", {
      staticClass: "mr-2 text-right"
    }, [_vm._v(" " + _vm._s("(".concat(winery.files.length, " file").concat(winery.files.length > 1 ? "s" : "", ")")) + " ")])]), _c(VExpansionPanelContent, [_c("div", {
      staticClass: "documents-inputs large-row-gap"
    }, _vm._l(winery.files, function (document) {
      return _c("div", {
        key: document.id
      }, [_c("div", {
        staticClass: "tag",
        class: !document.tag ? "font-italic" : "font-bold"
      }, [_c(VChip, {
        staticClass: "drawer-file-chip tag",
        attrs: {
          label: ""
        }
      }, [_c(VIcon, {
        staticClass: "tag-icon",
        attrs: {
          left: "",
          small: ""
        }
      }, [_vm._v("mdi-tag")]), _vm._v(" " + _vm._s(document.tag ? document.tag.name : "no tag") + " ")], 1)], 1), _c(VCheckbox, {
        attrs: {
          label: document.name,
          value: document,
          "hide-details": "auto"
        },
        on: {
          change: _vm.inputDocuments
        },
        model: {
          value: _vm.selectedDocuments,
          callback: function callback($$v) {
            _vm.selectedDocuments = $$v;
          },
          expression: "selectedDocuments"
        }
      })], 1);
    }), 0)])], 1);
  }), 1)], 1)]) : _vm._e(), _vm.wineryDocuments.length ? _c(VDivider) : _vm._e(), _c("div", [_vm.loadings.isLoadingPurchaseOrderFiles ? _c(VSkeletonLoader, {
    staticClass: "mt-2",
    attrs: {
      width: "100%",
      type: "text"
    }
  }) : !_vm.noFiles && _vm.isPurchaseOrder && _vm.purchaseOrderGlobalDocuments.length ? [_c("div", {
    staticClass: "documents-container"
  }, [_c("div", {
    staticClass: "documents-title mb-1"
  }, [_c("span", {
    staticClass: "--underline"
  }, [_vm._v("Add purchase order documents")]), _vm._v(" (optional) "), _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2 ml-2",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.selectAllGlobalPurchaseOrderFiles
    }
  }, [_vm._v(" Select all ")])], 1), _c("div", {
    staticClass: "documents-inputs large-row-gap"
  }, _vm._l(_vm.purchaseOrderGlobalDocuments, function (document) {
    return _c("div", {
      key: document.id
    }, [_c(VCheckbox, {
      attrs: {
        label: document.name,
        value: document,
        "hide-details": "auto"
      },
      on: {
        change: _vm.inputDocuments
      },
      model: {
        value: _vm.selectedDocuments,
        callback: function callback($$v) {
          _vm.selectedDocuments = $$v;
        },
        expression: "selectedDocuments"
      }
    })], 1);
  }), 0)])] : _vm._e()], 2), _c("div", [_vm.loadings.isLoadingPurchaseOrderRelatedFiles ? _c(VSkeletonLoader, {
    staticClass: "mt-2",
    attrs: {
      width: "100%",
      type: "text"
    }
  }) : !_vm.noFiles && _vm.isPurchaseOrder && _vm.purchaseOrderRelatedDocuments.length ? [_c("div", {
    staticClass: "documents-container"
  }, [_c("div", {
    staticClass: "documents-title mb-1"
  }, [_c("span", {
    staticClass: "--underline"
  }, [_vm._v("Add purchase order-related documents")]), _vm._v(" (optional) "), _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2 ml-2",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.selectAllPurchaseOrderRelatedFiles
    }
  }, [_vm._v(" Select all ")])], 1), _c("div", {
    staticClass: "documents-inputs large-row-gap"
  }, _vm._l(_vm.purchaseOrderRelatedDocuments, function (document) {
    return _c("div", {
      key: document.id
    }, [_c("div", {
      staticClass: "tag",
      class: !document.tag ? "font-italic" : "font-bold"
    }, [_c(VChip, {
      staticClass: "drawer-file-chip tag",
      attrs: {
        label: ""
      }
    }, [_c(VIcon, {
      staticClass: "tag-icon",
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-tag")]), _vm._v(" " + _vm._s(document.tag ? document.tag.name : "no tag") + " ")], 1)], 1), _c(VCheckbox, {
      attrs: {
        label: document.name,
        value: document,
        "hide-details": "auto"
      },
      on: {
        change: _vm.inputDocuments
      },
      model: {
        value: _vm.selectedDocuments,
        callback: function callback($$v) {
          _vm.selectedDocuments = $$v;
        },
        expression: "selectedDocuments"
      }
    })], 1);
  }), 0)])] : _vm._e()], 2), !_vm.noUploader ? [_c("div", {
    staticClass: "documents-title mt-4"
  }, [_c("span", {
    staticClass: "--underline"
  }, [_vm._v("Add extra files")]), _vm._v(" (optional) "), ((_vm$model = _vm.model) === null || _vm$model === void 0 || (_vm$model = _vm$model.files) === null || _vm$model === void 0 ? void 0 : _vm$model.length) > 0 ? _c("div", {
    staticClass: "mt-1"
  }, [_c(VAlert, {
    staticClass: "bypass-message --small",
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "orange",
      text: ""
    }
  }, [_vm._v(" Please ensure that none of these files are moved, renamed, or deleted on your computer before sending the email. ")])], 1) : _vm._e()]), _c("UploaderV2", {
    ref: "uploader_".concat(this.$vnode.key),
    staticClass: "w100p",
    attrs: {
      preloadedFiles: _vm.model.files && _vm.model.files.filter(function (x) {
        return !x.blob;
      }).map(function (x) {
        return x.temp;
      }),
      hideUploadButton: "",
      fileTypes: [".xlsx", ".xlsm", ".jpg", ".png", ".pdf"]
    },
    on: {
      sync: _vm.syncFiles
    }
  })] : _vm._e(), _vm._t("submit", null, {
    form: _vm.form
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };